var classList = require('dom-classlist');
var pubsub = require('pubsub');

module.exports = function () { 
	window.addEventListener('scroll', function(e) {
		pubsub.emit('window:scroll', window.scrollY)
	})
}